import { Image, Kanban, Link2, LogOut, Users } from 'lucide-react'
import { NavLink, Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../state/AuthContext'

// Registro de ferramentas do sistema — hoje só "Criador de Mídias".
// Novas ferramentas entram aqui e aparecem automaticamente na sidebar.
const TOOLS = [
  { to: '/criador-de-midias', label: 'Criador de Mídias', icon: Image },
  { to: '/link-bio', label: 'Link Bio', icon: Link2 },
  { to: '/tarefas', label: 'Tarefas', icon: Kanban },
  { to: '/usuarios', label: 'Usuários', icon: Users, adminOnly: true },
]

export function AppShell() {
  const { user, ready, logout, isAdmin } = useAuth()

  if (!ready) return null
  if (!user) return <Navigate to="/entrar" replace />

  return (
    <div className="app-shell">
      <aside className="app-sidebar">
        <img className="brand" src="/logo-lorena.png" alt="Lorena" />
        <nav aria-label="Ferramentas">
          {TOOLS.filter((tool) => !tool.adminOnly || isAdmin).map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} className={({ isActive }) => (isActive ? 'active' : undefined)}>
              <Icon size={16} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="account">
          <p>{user.name}</p>
          <button type="button" className="secondary" onClick={logout}>
            <LogOut size={14} />
            Sair
          </button>
        </div>
      </aside>
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  )
}
